import { useContext } from 'react';
import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { fg } from '@confluence/feature-gating';
import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';

/**
 * Eligibility hook for contextual collab onboarding for new end users experiment with following requirements to be eligible:
 *
 * Feature gate enabled
 * Is Nth user
 * Is new user
 * Desktop user
 */

export const useIsEligibleForContextualCollabOnboarding = () => {
	const isDesktopUser = !(isMobileUserAgent() || shouldShowMobileWeb());
	const {
		data: onboardingStateData,
		loading: onboardingStateLoading,
		error: onboardingStateError,
	} = useGetOnboardingState(
		[ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN],
		!fg('cc_engagement_contextual_collab_onboarding_for_neu'),
	);
	const { isNewUser: isNewUserFromContext } = useContext(SPAViewContext);

	const { isFoundingAdmin } = deserializeState(onboardingStateData);

	const isNthUser = !isFoundingAdmin && !onboardingStateLoading && !onboardingStateError;

	return {
		isEligibleForSpotlight:
			isDesktopUser &&
			isNthUser &&
			isNewUserFromContext &&
			fg('cc_engagement_contextual_collab_onboarding_for_neu'),
	};
};
